module.exports = __webpack_public_path__ + "img/advertise.bc03d2f0.gif";